import CommonLayout from 'components/CommonLayout';
import Body from 'containers/SiteMapPage/Body';
import messages from 'containers/SiteMapPage/messages';
import React from 'react';

const SiteMapPage = () => {
  return <CommonLayout title={messages.title_SiteMap} content={<Body />} />;
};

export default SiteMapPage;
